<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
      <div class="bg-white page-border">
      <!--page body contant -->
        <!-- header  -->
        <div class="row row-replace add-m-b">
            <div class="col-md-4 col-p h5">DASHBOARD / EMPLOYEE MASTER </div>
            <div class="col-md-4 col-p h5 text-center"></div>
            <div class="col-md-4 top-corner-items col-p"> 
                <button class="btn btn-primary btn-sm" (click)="leaveMaster()"> <i class="fa fa-plus"></i>Apply Leave</button>
            </div>
        </div>



     <!--data table--> 
     <div class="row row-replace">
        <div class="col-12 col-pn">
           <div class="card card-table flex-fill">
              <div class="card-body">
                 <div class="table-responsive table-h">
                    <table class="table custom-table table-nowrap mb-0 table-min text-center">
                       <thead>
                          <tr >
                             <th>Sr.no</th>
                             <th>Leave type</th>
                             <th>Emp Id</th>
                             <th>Emp Name</th>
                             <th>Applied Date</th>
                             <th>From Date</th>
                             <th>To Date</th>
                             <th>No of Days</th>
                             <th>Reason</th>
                             <th>Status</th>
                          </tr>
                       </thead>
                       <tbody>
                          <tr>
                             <td>0011</td>
                             <td>Work from home</td>
                             <td>12542</td>
                             <td>rohit singh</td>
                             <td>15-jan-2021</td>
                             <td>17-jan-2021</td>
                             <td>20-jan-2021</td>
                             <td>4</td>
                             <td>covid 19</td>
                             <td>tru/false</td>
                             
                           
                          </tr>
                       </tbody>
                    </table>
                 </div>
              </div>
           </div>
        </div>
     </div>
     <!--end table -->

     <!--records show status row-->
     <div class="row row-replace">
        <div class="col-12 col-pn">
        <div class="card-table flex-fill">
                <div class="card-body">
                    <div class="row">
                    <div class="col">            
                        <label>Showing 0 to 0 of 0 entries</label>        
                    </div>
                    <div class="col">  
                        <label class="float-right">       
                            <ul class="pagination">
                                <li class="page-item previous disabled">
                                    <a href="#" aria-controls="DataTables_Table_0" data-dt-idx="0" tabindex="0" class="page-link">Previous</a>
                                </li>
                                <li class="page-item active">
                                    <a href="#" aria-controls="DataTables_Table_0" data-dt-idx="1" tabindex="0" class="page-link">1</a>
                                </li>
                                <li class="page-item next disabled"><a href="#" aria-controls="DataTables_Table_0" data-dt-idx="2" tabindex="0" class="page-link">Next</a>
                                </li>
                            </ul>
                        </label>   
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>


      <!--end page body contant --> 
     
      </div>
    </div>
  </div>

  


<!-- Apply Employee Leave modal -->

  <div id="leave_master" class="modal custom-modal fade" role="dialog" style="display: none;" data-select2-id="add_leave" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Add Leave</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-group">
                        <label>Applying For<span class="text-danger">*</span></label>
                        <div class="col-9">
                           <label> Own </label> <input type="radio" value="own" name="a">
                           <label> Other</label> <input type="radio" value="other" name="a">
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Leave Type <span class="text-danger">*</span></label>
                       <select class="form-control">
                        <option>Casual Leave</option>
                        <option>Earned Leave</option>
                        <option>Leave Without Pay</option>
                        <option>Paternity Leave</option>
                        <option>Sabbatical Leave</option>
                        <option>Sick Leave</option>
                       </select>
                    </div>
                    <div class="form-group">
                        <label>From Date<span class="text-danger">*</span></label>
                        <input class="form-control" type="date">
                    </div>
                    <div class="form-group">
                        <label>To Date<span class="text-danger">*</span></label>
                        <input class="form-control" type="date">
                    </div>
                    <div class="form-group">
                        <label>No. Of Days <span class="text-danger">*</span></label>
                        <input class="form-control" placeholder="2" value="12" type="text">
                    </div>
                    <div class="form-group">
                        <label>Description <span class="text-danger">*</span></label>
                        <textarea rows="4" class="form-control"></textarea>
                    </div>
                    <div class="submit-section">
                        <button class="btn btn-primary btn-sm">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>